import { IApiError } from '@/models/apiError.model';
import { IPickup, IRegion, IRegionSettlement, ISettlement } from '@/models/regions.model';
import { IPagination } from '@/models/pagination.model';
import { TGetPickupQuery } from '../helpers/types';

export const REGIONS_SLICE_NAME = 'regions';

export interface RegionsState {
  regions: {
    data: IRegion[];
    meta: IPagination;
  } | null;
  pickups: {
    data: IPickup[];
    meta: IPagination;
  } | null;
  regionsSettlements: {
    data: IRegionSettlement[];
    meta: IPagination;
  } | null;
  query: TGetPickupQuery | null;
  pickup: IPickup | null;
  autoCompleteRegions: IRegion[] | null;
  autoCompleteSettlements: ISettlement[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: RegionsState = {
  regions: null,
  pickup: null,
  pickups: null,
  autoCompleteRegions: null,
  autoCompleteSettlements: null,
  regionsSettlements: null,
  query: null,
  isLoading: false,
  error: null,
};
